<template>
    <div class="user-section">
        <!-- Pulsante di login quando l'utente non è autenticato -->

        <!--<div v-show="isLoading" class="loading-overlay">
            <LoadingModal message="Caricamento in corso..." />
        </div>-->
        <div v-show="isLoading">
            <LoadingOverlay :show="isLoading" title="Caricamento in corso..." :message="loadingMessage" />
        </div>
        <div v-if="!this.$root.user" class="login-button">
            <a :href="this.$root.config.VITE_APP_BACKOFFICE_URL + '/auth/sso/login'"
                class="btn btn-outline-primary btn-sm tooltip-html-enabled"
                data-html-tooltip="<div class='tooltip-html-content' style='padding:1em; background-color: #ffffff; color: #1a1a1a'>clicca per accedere al servizio</div>">Accedi
                a Servizio Pareri Itaca</a>
        </div>

        <div v-else class="nav-item d-flex align-items-center">
            <a class="btn btn-outline-none p-0 btn-sm d-flex align-items-center" role="button"
                href="#" @click.prevent="doLogout">
                <svg class="icon icon-sm me-2">
                    <use :href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-logout'"></use>
                </svg>
                LOGOUT
            </a>


            <div v-if="!this.$root.user.active || this.showUseRequestIpa" class="ms-3">
                <UserDataIpaSection v-model:show="showUseRequestIpa" @switch="switchToUseRequest" />
            </div>

            <div v-if="showUseRequest" class="ms-3">
                <UseRequest v-model:show="showUseRequest" @switchBack="switchToIpaSelection" />
            </div>
        </div>
    </div>
</template>

<script>

import UseRequest from "./UseRequest.vue";
import UserDataIpaSection from "./UserDataIpaSection.vue";
import LoadingModal from "./LoadingModal.vue";
import LoadingOverlay from './LoadingOverlay.vue';

export default {
    name: "UserSection",
    components: {
        UseRequest,
        UserDataIpaSection,
        LoadingModal,
        LoadingOverlay
    },
    data() {
        return {
            showUseRequest: false,
            showUseRequestIpa: false,
            isLoading: true
        }
    },
    mounted() {
        //localStorage.setItem('currentView', 'ArticlesView');
        this.showUseRequest = false;
        //if (this.$root.user && !this.$root.user.active && !this.$root.user.activable && !localStorage.getItem('showed_user_request_ipa')) {
        if (this.$root.user && !this.$root.user.active && !localStorage.getItem('showed_user_request_ipa')) {
            this.showUseRequestIpa = true;

            //localStorage.setItem('showed_user_request', true);
            //localStorage.setItem('showed_user_request_ipa', true);
        }

        // Inizializza i tooltip HTML personalizzati
        this.initHtmlTooltips();
        this.isLoading = false;
    },
    methods: {
        switchToUseRequest() {
            this.showUseRequestIpa = false;
            this.showUseRequest = true;
        },
        switchToIpaSelection() {
            this.showUseRequest = false;
            this.showUseRequestIpa = true;
        },
        doLogout() {
            const base = this.$root.config.VITE_APP_BACKOFFICE_URL + '/auth/sso/logout';
            const token = localStorage.getItem('token');
            window.location.href = token ? (base + '?token=' + encodeURIComponent(token)) : base;
        },
        initHtmlTooltips() {
            // Trova tutti gli elementi con attributo data-html-tooltip
            const tooltipElements = document.querySelectorAll('.tooltip-html-enabled');

            tooltipElements.forEach(element => {
                // Ottieni il contenuto HTML del tooltip
                const tooltipContent = element.getAttribute('data-html-tooltip');
                if (!tooltipContent) return;

                // Crea un elemento div per il tooltip
                const tooltipDiv = document.createElement('div');
                tooltipDiv.className = 'custom-html-tooltip';
                tooltipDiv.innerHTML = tooltipContent;
                tooltipDiv.style.position = 'fixed'; // Usiamo fixed invece di absolute
                tooltipDiv.style.top = '0';
                tooltipDiv.style.left = '0';
                tooltipDiv.style.backgroundColor = 'rgba(52, 58, 64, 0.95)';
                tooltipDiv.style.color = '#fff';
                tooltipDiv.style.padding = '0';
                tooltipDiv.style.borderRadius = '4px';
                tooltipDiv.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.2)';
                tooltipDiv.style.zIndex = '9999'; // Z-index molto alto per essere sopra tutto
                tooltipDiv.style.maxWidth = '300px';
                tooltipDiv.style.wordWrap = 'break-word';
                tooltipDiv.style.backdropFilter = 'blur(2px)';
                tooltipDiv.style.transition = 'opacity 0.2s ease-in-out';
                tooltipDiv.style.opacity = '0';
                tooltipDiv.style.pointerEvents = 'auto'; // Permette l'interazione con il tooltip
                tooltipDiv.style.display = 'none';

                // Aggiungi il tooltip al body
                document.body.appendChild(tooltipDiv);

                // Mostra il tooltip al passaggio del mouse
                element.addEventListener('mouseenter', () => {
                    const rect = element.getBoundingClientRect();
                    tooltipDiv.style.left = rect.left + 'px';
                    tooltipDiv.style.top = rect.bottom + 'px'; // Con position:fixed non serve aggiungere scrollY
                    tooltipDiv.style.opacity = '1';
                    tooltipDiv.style.display = 'block';
                });

                // Gestione del mouse sul tooltip stesso
                tooltipDiv.addEventListener('mouseenter', () => {
                    tooltipDiv.style.opacity = '1';
                    tooltipDiv.style.display = 'block';
                });

                tooltipDiv.addEventListener('mouseleave', () => {
                    tooltipDiv.style.opacity = '0';
                    setTimeout(() => {
                        if (tooltipDiv.style.opacity === '0') {
                            tooltipDiv.style.display = 'none';
                        }
                    }, 200);
                });

                // Nascondi il tooltip quando il mouse esce dall'elemento (ma non se va sul tooltip)
                element.addEventListener('mouseleave', (event) => {
                    // Verifica se il mouse è entrato nel tooltip
                    const toElement = event.relatedTarget;
                    if (toElement === tooltipDiv || tooltipDiv.contains(toElement)) {
                        // Il mouse è entrato nel tooltip, non fare nulla
                        return;
                    }

                    // Altrimenti nascondi il tooltip dopo un breve ritardo
                    setTimeout(() => {
                        // Controlla se il mouse è sul tooltip prima di nasconderlo
                        const hoveredElements = document.querySelectorAll(':hover');
                        let isMouseOverTooltip = false;

                        // Controlla se il tooltip è tra gli elementi su cui è il mouse
                        hoveredElements.forEach(el => {
                            if (el === tooltipDiv || tooltipDiv.contains(el)) {
                                isMouseOverTooltip = true;
                            }
                        });

                        if (!isMouseOverTooltip) {
                            tooltipDiv.style.opacity = '0';
                            setTimeout(() => {
                                if (tooltipDiv.style.opacity === '0') {
                                    tooltipDiv.style.display = 'none';
                                }
                            }, 200);
                        }
                    }, 100);
                });
            });
        }
    },
    beforeUnmount() {
        // Rimuovi tutti i tooltip HTML personalizzati quando il componente viene smontato
        document.querySelectorAll('.custom-html-tooltip').forEach(el => el.remove());
    }
}
</script>

<style scoped>
.user-dropdown {
    max-width: 100%;
    width: 100%;
}

.dropdown-menu {
    max-width: 100%;
    width: 100%;
}

.dropdown-menu.dropdown-menu-end.show {
    display: table
}

.user-name-display {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-section {
    display: inline-block;
}

/* Stile personalizzato per l'avatar dell'utente */
.avatar {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    border-radius: 50%;
}

.avatar-xl {
    width: 48px;
    height: 48px;
}

.avatar-sm {
    width: 28px;
    height: 28px;
}

/* Icone */
.icon {
    width: 24px;
    height: 24px;
    margin-left: 0px !important;
}

.icon-sm {
    width: 16px;
    height: 16px;
}

.icon-xs {
    width: 14px;
    height: 14px;
}

.icon-secondary {
    fill: #5c6f82;
}

.icon-danger {
    fill: #d9364f;
}

/* Margini e spaziature */
.ms-3 {
    margin-left: 1rem;
}

.me-2 {
    margin-right: 0.5rem;
}

/* Status badges - Bootstrap Italia */
.badge {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
}

.badge-warning {
    background-color: #ffd700;
    color: #1c2024;
}

.badge-info {
    background-color: #0066cc;
    color: #fff;
}

.badge-danger {
    background-color: #d9364f;
    color: #fff;
}

/* Custom HTML Tooltip */
.tooltip-html-container {
    position: relative;
    display: inline-block;
}

.tooltip-html-enabled {
    position: relative;
}

/* Rimosso lo stile CSS per il tooltip con pseudo-elemento poiché useremo JavaScript */


.tooltip-auth-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
}

.tooltip-auth-options div {
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
}

.loading-overlay {
    position: fixed;
    /* Copre tutta la finestra */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    /* Semi-trasparente */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    /* Deve essere sopra tutto */
    overflow: hidden;
    /* Previene scroll */
}
</style>